import React from 'react'
import constantes from '../../constantes/constantes'
import ItemLista from './itemLista'

const operaciones = constantes.operaciones

const ListaOperaciones = (): any => {
  return (
    <div className="py-[8%]">
      <div className="md:grid md:grid-cols-2 gap-x-[136px] gap-y-[84px] w-full max-w-[1200px] mx-auto">
        {operaciones.map((data, index) => (
          <ItemLista key={index} data={data} />
        ))}
      </div>
    </div>
  )
}

export default ListaOperaciones
